import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import aboutimg from "../../assets/img/About-Us.webp";

const AboutSummary = () => {
  return (
    <>
      <section className="section-spacing-x section-spacing-y about-us">
        <Container fluid>
          <Row>
            <Col lg={5} className="mb-lg-0 mb-3">
              <div className="w-100 h-100">
                <img
                  src={aboutimg}
                  alt="Diamond Earing Verification | Best Diamond Lab in India | Sreehari Diamond Laboratory "
                  className="img-fluid w-100 h-100"
                />
              </div>
            </Col>
            <Col lg={7}>
              <h1 className="heading mb-3">About Us</h1>
              <p className="para-content mb-3">
                Sreehari Diamond Laboratory has been proud to be at the
                forefront of the lab-grown diamond revolution in India. Founded
                with a vision to transform the diamond industry through
                innovation, ethics, and sustainability, our laboratory in Tamil
                Nadu combines cutting-edge technology with a passion for
                craftsmanship borne from India's rich heritage. Our aim for a
                diamond certificate is to provide the highest level of grading
                possible for a diamond. The report gives a precise description
                of the stone's characteristics according to the 4cs - Carat
                weight, Clarity, Cut, and Color, with dimensions.{" "}
              </p>
              <p className="para-content mb-3">
                Our graders are the most professional in the diamond business,
                with great experience and a sharp eye for detail from our
                gemologists. We provide certificates for natural diamonds,
                diamond jewelry, and lab-grown diamonds. We have the experience
                of seeing the diamond analysis. Our gemologist is an alumnus of
                IDI Surat is a premier institution focused on education and
                training within the gem and jewelry sector, particularly
                diamonds.{" "}
              </p>{" "}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AboutSummary;
